<template>
  <div class="locations container">

    <!-- ------------------------------- Modal: Add/Modify Locations ------------------------------------------ -->

    <div>
		<CModal title="Location Details" color="info" :show.sync="locationModal" size="lg">		  
			<div slot="footer">
				<button class="btn btn-info" v-on:click.prevent="serverCall('addUpdateLocation')">Save</button>
				<button class="btn btn-info ml-2" v-on:click.prevent="locationModal=false">Close</button>
			</div>

			<form>
				<div class="form-group row">
					<label for="name" class="col-sm-2 col-form-label text-right">Name</label>
					<div class="col-sm-10">
						<input type="text" id="name" class="form-control" 
								v-model="location.name" required="">
					</div>
				</div>

				<div class="form-group row">
					<label for="latitude" class="col-sm-2 col-form-label text-right">Latitude</label>
					<div class="col-sm-4">
						<input type="number" id="latitude" class="form-control" 
								v-model="location.latitude" required="">
					</div>
					<label for="longitude" class="col-sm-2 col-form-label text-right">Longitude</label>
					<div class="col-sm-4">
						<input type="number" id="longitude" class="form-control" 
								v-model="location.longitude" required="">
					</div>
				</div>
				<div class="form-group row">
					<label class="col-sm-2 col-form-label text-right"></label>
					<a href="https://www.latlong.net/convert-address-to-lat-long.html"  target="_blank">
						(Link to get Latitude-Longitude from postal adddress)</a>
				</div>
				<div class="form-group row">
					<label for="tolerance" class="col-sm-2 col-form-label text-right">Tolerance</label>
					<div class="col-sm-10">
						<input type="number" min=100 id="tolerance" class="form-control" 
								v-model="location.tolerance" v-maska="['#*']">
					</div>
				</div>

				<p class="text-danger" align="left">{{locationAlert}}</p>
			</form>

		</CModal>
	</div>

    <!-- ---------------------------------------  Location List -------------------------------------------------- -->

	<vue-good-table ref="locationsTable" :columns="colLocations" :rows="rowLocations" 
							@on-row-click="rowChanged" 
							:selectOptions="{
									enabled: true,
									selectOnCheckboxOnly: false, 
							}">
			<div slot="table-actions">
				<CButton class="mr-3" color="primary" v-on:click.prevent="openNewLocationDetails()">
					Add
				</CButton>
			</div>
			<div slot="selected-row-actions">
				<CButton color="info" v-on:click.prevent="openExistingLocationDetails()">
					Modify
				</CButton>
				<CButton class="ml-2" color="info" v-on:click.prevent="serverCall('deleteLocation')">
					Delete
				</CButton>
			</div>
	</vue-good-table>

	<p class="text-danger" align="left">{{alert}}</p>

	<main id="main">
	</main>

  </div>
</template>

<script>
import axios from "axios"
import { firebase } from '@firebase/app'
import "firebase/auth"

export default {
	name: 'locations',

    components: {
		},
		
	data () {
		return {
			alert: '',
			locationAlert: '',

			locationModal: false,

			locations: [],

			location: {
					locDocId: '',
					name: '',
					latitude: '',
					longitude: '',
					tolerance: 100
			},

			addFlag: false,

			colLocations: [
					{
							label: 'Name',
							field: 'name',
							html: false
					},
					{
							label: 'Latitude, Longitude - Map Link',
							field: 'locUrl',
							html: true
					},
					{
							label: 'Tolerance (in feets)',
							field: 'tolerance',
							html: false
					},
			],

			rowLocations: [],
			curRowSelected: null,		
		}
	},

	computed: {
	},

	mounted(){
		this.serverCall('getLocations')
	},

	methods: {
        serverCall(name) {
            var self = this
			self.alert = null

			firebase.auth().onAuthStateChanged(user => {
				if (user) {
					user.getIdToken(true).then(idToken => {
						var org = self.getUserOrg()
						switch(name) {
							case "getLocations":
								self.getLocations(idToken, org)
								break;
							case "addUpdateLocation":
								self.addUpdateLocation(idToken, org)
								break;
							case "deleteLocation":
								self.deleteLocation(idToken, org)
								break;
							default:
								console.log("Unknown function: " + name)
						}
					})
				}
				else {
					self.alert = "Please login first."
				}
			})
		},

        // Fetch locations for the given org
        getLocations(authToken, org) {
            var self = this
			self.alert = null

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/GetLocations/',
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						self.rowLocations = response.data.locList
					}
				})
				.catch(function (error) {
					self.alert = String(error)
				})
		},

		rowChanged(params){	
			// Current selected Row
			if (this.curRowSelected != null){
				// If new row is not same as previous row, uncheck previous row
				if (this.curRowSelected.originalIndex!=params.row.originalIndex)
					this.curRowSelected.vgtSelected = false
			}
			// New selected row
			this.curRowSelected = params.row
		},

		// Open details for existing location
		openExistingLocationDetails(){
            var self = this
			self.alert = null

            // Check if Location is selected
			if (self.curRowSelected==null){
				self.alert = "Location not selected."
				return
			}

			// Initialize location object
			self.location.locDocId = self.curRowSelected.locDocId
			self.location.name = self.curRowSelected.name
			self.location.latitude = self.curRowSelected.latitude
			self.location.longitude = self.curRowSelected.longitude
			self.location.tolerance = self.curRowSelected.tolerance

			// Show modal with location values
			//$('#locationDetailsModal').modal('show')
			this.locationModal = true
		},

		// Open details for new location
		openNewLocationDetails(){
            var self = this
			self.alert = null

			// Initialize location object
			self.location.locDocId = ''
			self.location.name = ''
			self.location.latitude = ''
			self.location.longitude = ''
			self.location.tolerance = 100
			
			// Show modal with location values
			//$('#locationDetailsModal').modal('show')
			self.locationModal = true
		},

		// Save location changes - for new as well as existing locations
        addUpdateLocation(authToken, org) {
            var self = this
            this.locationAlert = ""

            if (!self.location.name) {
                self.locationAlert= 'Location name not specified.'
                return
            }

			var formData = new FormData();
			formData.append("locDocId", self.location.locDocId);
			formData.append("name", self.location.name);
			formData.append("latitude", self.location.latitude);
			formData.append("longitude", self.location.longitude);
			formData.append("tolerance", self.location.tolerance);

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/AddUpdateLocation/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if (response.data.err != '') {
						self.locationAlert = response.data.err
					}
					else {
						// Refresh location list on the screen
						self.serverCall('getLocations')						
						//$('#locationDetailsModal').modal('hide')
						self.locationModal = false
					}
				})
				.catch(function (error) {
					self.locationAlert = String(error)
				})
		},

		// Delete Location
		deleteLocation(authToken, org){
			var self = this
						
            // Check if Location is selected
			if (self.curRowSelected==null){
				self.alert = "Location not selected."
				return
			}

			// Initialize location object
			var formData = new FormData();
			formData.append("locDocId", self.curRowSelected.locDocId);

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/DeleteLocation/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						// Refresh location list on the screen
						self.serverCall('getLocations')
					}				
				})
				.catch(function (error) {
					self.locationAlert = String(error)
				})
		},

	},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
